import {Pipe, PipeTransform} from '@angular/core';
import {ChoiceInputItem} from '../../../form-elements/models/form-elements.model';

@Pipe({
  name: 'singleChoiceInputType'
})
export class SingleChoiceInputTypePipe implements PipeTransform {

  transform(value: any, choices: ChoiceInputItem[]): string {
    return this.getTypeByValue(value, choices);
  }

  getTypeByValue(code: any, choiceInputItem: ChoiceInputItem[]): string {
    if (choiceInputItem) {
      const found = choiceInputItem.find(item => item.value === code);
      if (found) {
        return found.label;
      }
    }

    return code;
  }

}
